import { SVGProps } from 'react';

export const SuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='66'
    height='65'
    viewBox='0 0 66 65'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g filter='url(#filter0_di_1149_178891)'>
      <path
        d='M29.9252 4.22112C30.9694 2.85163 33.0306 2.85163 34.0748 4.22112C34.9376 5.3527 36.548 5.58424 37.6946 4.74157C39.0823 3.72174 41.06 4.30243 41.6761 5.91064C42.1851 7.23946 43.6651 7.91532 45.0027 7.42984C46.6215 6.84228 48.3555 7.95663 48.4935 9.67326C48.6075 11.0917 49.8371 12.1571 51.2573 12.0681C52.9761 11.9604 54.3259 13.5182 53.9747 15.2041C53.6845 16.5972 54.5641 17.9659 55.9518 18.2807C57.6314 18.6616 58.4876 20.5365 57.6756 22.0552C57.0047 23.3101 57.4631 24.8712 58.7059 25.5641C60.2101 26.4028 60.5034 28.443 59.2965 29.6715C58.2992 30.6865 58.2992 32.3135 59.2965 33.3285C60.5034 34.557 60.2101 36.5972 58.7059 37.4359C57.4631 38.1288 57.0047 39.6899 57.6756 40.9448C58.4876 42.4635 57.6314 44.3384 55.9518 44.7193C54.5641 45.0341 53.6845 46.4028 53.9747 47.7958C54.3259 49.4818 52.9761 51.0396 51.2573 50.9319C49.8371 50.8429 48.6075 51.9083 48.4935 53.3267C48.3555 55.0434 46.6215 56.1577 45.0027 55.5702C43.6651 55.0847 42.1851 55.7605 41.6761 57.0894C41.06 58.6976 39.0823 59.2783 37.6946 58.2584C36.548 57.4158 34.9376 57.6473 34.0748 58.7789C33.0306 60.1484 30.9694 60.1484 29.9252 58.7789C29.0624 57.6473 27.452 57.4158 26.3054 58.2584C24.9177 59.2783 22.94 58.6976 22.3239 57.0894C21.8149 55.7605 20.3349 55.0847 18.9973 55.5702C17.3785 56.1577 15.6445 55.0434 15.5065 53.3267C15.3925 51.9083 14.1629 50.8429 12.7427 50.9319C11.0239 51.0396 9.67412 49.4818 10.0253 47.7958C10.3155 46.4028 9.43589 45.0341 8.04816 44.7193C6.36864 44.3384 5.51241 42.4635 6.32437 40.9448C6.99526 39.6899 6.5369 38.1288 5.29405 37.4359C3.78989 36.5972 3.49656 34.557 4.70351 33.3285C5.70078 32.3135 5.70078 30.6865 4.70351 29.6715C3.49656 28.443 3.78989 26.4028 5.29405 25.5641C6.5369 24.8712 6.99526 23.3101 6.32436 22.0552C5.51241 20.5365 6.36864 18.6616 8.04816 18.2807C9.43589 17.9659 10.3155 16.5972 10.0253 15.2041C9.67412 13.5182 11.0239 11.9604 12.7427 12.0681C14.1629 12.1571 15.3925 11.0917 15.5065 9.67326C15.6445 7.95663 17.3785 6.84228 18.9973 7.42984C20.3349 7.91532 21.8149 7.23946 22.3239 5.91064C22.94 4.30243 24.9177 3.72174 26.3054 4.74157C27.452 5.58424 29.0624 5.3527 29.9252 4.22112Z'
        fill='#0BC05E'
      />
      <path
        d='M30.3228 4.52429C31.1669 3.41724 32.8331 3.41724 33.6772 4.52429L34.0748 4.22112L33.6772 4.52429C34.7053 5.87271 36.6243 6.14862 37.9907 5.14448C39.1125 4.32008 40.7112 4.78949 41.2092 6.08951C41.8158 7.67297 43.5793 8.47835 45.1732 7.89984C46.4819 7.42488 47.8835 8.32568 47.9951 9.71334C48.131 11.4036 49.5962 12.6732 51.2886 12.5671C52.678 12.4801 53.7691 13.7393 53.4852 15.1022C53.1394 16.7622 54.1876 18.3932 55.8412 18.7683C57.1989 19.0762 57.8911 20.5918 57.2347 21.8195C56.4352 23.3149 56.9814 25.1751 58.4625 26.0009C59.6784 26.6788 59.9155 28.328 58.9398 29.3211C57.7514 30.5306 57.7514 32.4694 58.9398 33.6789C59.9155 34.672 59.6784 36.3212 58.4625 36.9991C56.9814 37.8249 56.4352 39.6851 57.2347 41.1805C57.8911 42.4082 57.1989 43.9238 55.8412 44.2317C54.1876 44.6068 53.1394 46.2378 53.4852 47.8978C53.7691 49.2607 52.678 50.5199 51.2886 50.4329C49.5962 50.3268 48.131 51.5964 47.9951 53.2867C47.8835 54.6743 46.4819 55.5751 45.1732 55.1002C43.5793 54.5216 41.8158 55.327 41.2092 56.9105C40.7112 58.2105 39.1125 58.6799 37.9907 57.8555C36.6243 56.8514 34.7053 57.1273 33.6772 58.4757C32.8331 59.5828 31.1669 59.5828 30.3228 58.4757C29.2947 57.1273 27.3757 56.8514 26.0093 57.8555C24.8875 58.6799 23.2888 58.2105 22.7908 56.9105C22.1842 55.327 20.4207 54.5216 18.8268 55.1002C17.5181 55.5751 16.1165 54.6743 16.0049 53.2867C15.869 51.5964 14.4038 50.3268 12.7114 50.4329C11.322 50.5199 10.2309 49.2607 10.5148 47.8978C10.8606 46.2378 9.81243 44.6068 8.15875 44.2317C6.8011 43.9238 6.10895 42.4082 6.76531 41.1805C7.56477 39.6851 7.01857 37.8249 5.53755 36.9991C4.32164 36.3212 4.08452 34.672 5.06017 33.6789C6.24856 32.4694 6.24856 30.5306 5.06017 29.3211C4.08452 28.328 4.32164 26.6788 5.53755 26.0009C7.01857 25.1751 7.56477 23.3149 6.7653 21.8195C6.10895 20.5918 6.8011 19.0762 8.15875 18.7683C9.81243 18.3932 10.8606 16.7622 10.5148 15.1022C10.2309 13.7393 11.322 12.4801 12.7114 12.5671C14.4038 12.6732 15.869 11.4036 16.0049 9.71334C16.1165 8.32568 17.5181 7.42488 18.8268 7.89984C20.4207 8.47835 22.1842 7.67297 22.7908 6.08951C23.2888 4.78949 24.8875 4.32008 26.0093 5.14448C27.3757 6.14862 29.2947 5.87271 30.3228 4.52429Z'
        stroke='url(#paint0_linear_1149_178891)'
      />
    </g>
    <path
      d='M22 33L30 41L42 23'
      stroke='white'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <filter
        id='filter0_di_1149_178891'
        x='0.955256'
        y='0.193848'
        width='64.0895'
        height='64.6123'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='1' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.117194 0 0 0 0 0.389414 0 0 0 0 0.242024 0 0 0 0.9 0'
        />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1149_178891' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_1149_178891'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='3' />
        <feGaussianBlur stdDeviation='2.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.507504 0 0 0 0 0.895849 0 0 0 0 0.685585 0 0 0 1 0'
        />
        <feBlend mode='normal' in2='shape' result='effect2_innerShadow_1149_178891' />
      </filter>
      <linearGradient
        id='paint0_linear_1149_178891'
        x1='19.1951'
        y1='1.86585'
        x2='44.0732'
        y2='61.8659'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.0194452' stopColor='#0BC05E' />
        <stop offset='1' stopColor='#078D44' />
      </linearGradient>
    </defs>
  </svg>
);
